import React, { useState } from "react";
import { Building2, AlertTriangle, ShieldCheck, CreditCard, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { paymentsAPI } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function BusinessStatusPanel() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  if (!user || user.account_type !== "business") return null;

  const subUntil = user.business_subscription_until ? new Date(user.business_subscription_until) : null;
  const now = new Date();
  const active = subUntil && subUntil > now;
  const expiringIn30 = active && (subUntil - now) / 86400000 < 30;

  const subscribe = async () => {
    setLoading(true);
    try {
      const { url } = await paymentsAPI.createBusinessSubscription(window.location.origin);
      if (url) window.location.href = url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Errore pagamento");
      setLoading(false);
    }
  };

  return (
    <div className={`rounded-2xl p-5 border-2 ${active ? "bg-emerald-50 border-emerald-200" : "bg-amber-50 border-amber-300"}`} data-testid="business-status-panel">
      <div className="flex items-start gap-3">
        <div className={`shrink-0 w-12 h-12 rounded-xl flex items-center justify-center ${active ? "bg-emerald-500 text-white" : "bg-amber-500 text-white"}`}>
          {active ? <ShieldCheck className="w-6 h-6" /> : <AlertTriangle className="w-6 h-6" />}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <h3 className={`font-black ${active ? "text-emerald-900" : "text-amber-900"}`}>
              {active ? "Iscrizione Azienda attiva" : "Iscrizione Azienda necessaria"}
            </h3>
            <span className="text-[10px] font-bold uppercase tracking-wider bg-[#1d3d3a] text-amber-300 px-2 py-0.5 rounded-full inline-flex items-center gap-1">
              <Building2 className="w-3 h-3" /> PRO
            </span>
          </div>
          {user.company_name && (
            <div className="text-xs text-slate-700 mt-1">
              <strong>{user.company_name}</strong> · P.IVA {user.vat_number}
            </div>
          )}
          <p className={`text-sm mt-2 ${active ? "text-emerald-800" : "text-amber-900"}`}>
            {active
              ? <>Iscrizione valida fino al <strong>{subUntil.toLocaleDateString("it-IT")}</strong>. Pubblica annunci illimitati a €0,50 ciascuno.</>
              : <>Per pubblicare annunci devi completare l'iscrizione annuale (<strong>€9,99/anno</strong>). Successivamente pagherai <strong>€0,50</strong> per ogni annuncio pubblicato.</>
            }
          </p>
          {(!active || expiringIn30) && (
            <Button
              onClick={subscribe}
              disabled={loading}
              className={`mt-3 rounded-full ${active ? "bg-emerald-600 hover:bg-emerald-700" : "bg-amber-500 hover:bg-amber-600"} text-white`}
              data-testid="business-subscribe-button"
            >
              {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <CreditCard className="w-4 h-4 mr-2" />}
              {active ? "Rinnova subito (€9,99)" : "Attiva iscrizione (€9,99)"}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
